import { takeLatest, put, call } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { api } from '@app/react/common/api';
import {
    recommendDesignAction,
    TRecommendDesignParam,
} from '@app/react/action';
import { ArrowType, OrderType } from '@app/react/const/type';
import { GetResponseRecommendDesigns } from '@app/react/api';
import { safe } from './common/safe';
import { convArrowType, convOrderType } from './conv';

const fetchRecommend = (
    arrowType: ArrowType,
    orderType: OrderType,
) => {
    const at = convArrowType(arrowType);
    const ot = convOrderType(orderType);

    return api.orderMadeFunctionGetRecommendDesignsGet({
        arrowType: at,
        orderType: ot,
    });
};

type Result = {
    result: GetResponseRecommendDesigns | null;
    error: Error | null;
};

function* fetchRecommendDesign(action: Action<TRecommendDesignParam>) {
    const { arrowType, orderType } = action.payload;

    const { result, error }: Result = yield safe(
        call(fetchRecommend, arrowType, orderType),
    );
    if (error !== null) {
        console.error('[saga] fetch recommend design', error);
        yield put(
            recommendDesignAction.failed({
                params: action.payload,
                error: {
                    message: error.message,
                },
            }),
        );
        return;
    }

    yield put(
        recommendDesignAction.done({
            params: action.payload,
            result: {
                data: result?.recommendDesigns || [],
            },
        }),
    );
}

export const recommendDesignSaga = [
    takeLatest(recommendDesignAction.started.type, fetchRecommendDesign),
];
